export default {"src":"/_next/static/media/plus.7d21c0d4.svg","height":32,"width":18,"blurWidth":0,"blurHeight":0};